import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterEvent } from '@angular/router';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { ModalService } from '../../../core/modal/modal.service';
import { ModalModule } from '../../../core/modal/modal.module';
import { SharedModule } from '../../../shared/shared.module';
import { CtoApiService } from '../../../core/modules/cto/cto-api.service';

@Component({
  selector: 'tax-kkm-modal',
  templateUrl: './kkm-modal.component.html',
  styleUrls: ['./kkm-modal.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    SharedModule,
    NgIf,
    NgFor,
    FormsModule,
  ],
})
export class KkmModalComponent implements OnInit, OnDestroy {
  // @ts-ignore
  @Input() initialState;

  filterParam: string = '';
  // @ts-ignore
  kkms: Array<object>;
  isLoaded: boolean = false;
  selectedKkm: Array<number | string> = [];
  paginationFrom: number = 0;
  isFullList: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private ctoApiService: CtoApiService,
    private modalService: ModalService,
  ) {
  }

  ngOnInit(): void {
    if (this.initialState && this.initialState.length) {
      this.selectedKkm = [...this.initialState];
    }
    this.setInitialKkmList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  private setInitialKkmList(): void {
    this.getKkms(this.paginationFrom)
      .pipe(takeUntil(this.destroy$))
      .subscribe((kkmsList) => {
        this.isLoaded = false;
        this.kkms = kkmsList;
        this.paginationFrom += 3;
        this.isLoaded = true;
      });
  }

  kkmCheckboxChange(event: Event | RouterEvent, id: number): void {
    if (event instanceof RouterEvent) return;

    if ((event.currentTarget as HTMLInputElement).checked) {
      if (!this.selectedKkm.includes(id)) {
        this.selectedKkm.push(id);
      }
    } else if (this.selectedKkm.includes(id)) {
      this.selectedKkm.splice(this.selectedKkm.indexOf(id), 1);
    }
  }

  // @ts-ignore
  rpCheckboxChange(event: Event | RouterEvent, kkms): void {
    if (event instanceof RouterEvent) return;

    // @ts-ignore
    kkms.map((kkm) => {
      kkm.selected = (event.currentTarget as HTMLInputElement).checked;
      this.kkmCheckboxChange(event, kkm.id);
    });
  }

  // @ts-ignore
  isRpChecked(retailPlace) {
    // @ts-ignore
    return retailPlace.kkms.every(kkm => kkm.selected);
  }

  private getKkms(paginationFrom: number, criteria?: string): Observable<any> {
    const paginationTo: number = paginationFrom + 3;
    return this.markSelectedKkm(this.ctoApiService.fetchKkms({
      criteria: criteria || '',
      pagination: {
        from: paginationFrom, to: paginationTo,
      },
    }));
  }

  markSelectedKkm(stream$: Observable<any>): Observable<any> {
    // @ts-ignore
    return stream$.pipe(map(item => item.map((i) => {
      // @ts-ignore
      i.kkms = i.kkms.map((kkm) => {
        kkm.selected = this.selectedKkm.includes(kkm.id);
        return kkm;
      });
      return i;
    })));
  }

  updateKkmsListByParams(event: Event | RouterEvent): void {
    if (event instanceof RouterEvent) return;

    this.paginationFrom = 0;
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue) {
      this.getKkms(this.paginationFrom, inputValue)
        .pipe(takeUntil(this.destroy$))
        .subscribe((kkmsList) => {
          this.isLoaded = false;
          this.paginationFrom = 3;
          this.kkms = kkmsList;
          this.isFullList = false;
          this.isLoaded = true;
        });
    } else {
      this.setInitialKkmList();
    }
  }

  // @ts-ignore
  private addNextKkmsPart(kkmsList): void {
    this.isLoaded = false;
    this.paginationFrom += 3;
    this.kkms = this.kkms.concat(kkmsList);
    this.isFullList = kkmsList.length === 0;
  }

  // @ts-ignore
  @HostListener('window:scroll', ['$event']) onElementScroll(event) {
    if (event.scrollTop + event.clientHeight >= event.scrollHeight && !this.isFullList) {
      this.getKkms(this.paginationFrom, this.filterParam)
        .pipe(takeUntil(this.destroy$))
        .subscribe((kkmsList) => {
          this.addNextKkmsPart(kkmsList);
          this.isLoaded = true;
        });
    }
  }

  closeModal() {
    this.modalService.close();
  }

  saveSelectedKkm(): void {
    this.modalService.close(this.selectedKkm);
  }
}
